import { useEffect, useState } from 'react'
import { getSubmitForm } from '../helpers/forms_helper';
import showToast from "../helpers/show_toast";
import { Card, CardBody, CardImg, Col, Row } from 'reactstrap';
import { Link, useNavigate } from 'react-router-dom';

const NewJoiners = () => {
    const navigate = useNavigate();
    useEffect(() => {
        fetch_data();
    }, []);
    const [allData, setAllData] = useState([]);
    const fetch_data = async () => {
        // let url = process.env.VITE_APP_BASEURL + "news/getall";
        let url = "https://api.jmialumnivic.com.au/teams/get_last6";
        const response = await getSubmitForm(url, '')
        if (response && response.status === 1) {
            setAllData(response.data)
        } else {
            showToast(response.error, "error")
        }
    };
    const handle_viewDetails = (data) => {
        navigate(`/team_details/${btoa(data._id)}`, { state: data })
    }
    return (
        <>
            <div id='ourteam' className='my-5'></div>
            <section className='newjoiners_section mb-5'>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 col-md-12 text-center">
                            <div className="new_joiners_heading title_heading">
                                <h1> Leadership Team</h1>
                            </div>
                        </div>
                    </div>
                    <Row className='data_row_here'>
                        {allData && allData.length > 0 ?
                            allData.map((data, idx) => {
                                return (
                                    <>
                                        <div className="col-lg-2 col-md-4 col-sm-4 col-6 " key={idx}>
                                            <Card className="new_joiners_card " onClick={() => handle_viewDetails(data)} style={{ cursor: 'pointer' }}>
                                                <CardImg src={data.image_url ? data.image_url : '/noimg.jpg'} alt="" />
                                                <CardBody className='text-center px-1  pb-0'>
                                                    <div className="newjoiner_details">
                                                        <h6>{data.name}</h6>
                                                        <p className='text-center'>{data.designation}</p>
                                                    </div>
                                                </CardBody>
                                            </Card>
                                        </div>
                                    </>
                                )
                            })
                            : ''}
                    </Row>
                    <Row >
                        <Col md={12}>
                            <div className="mb-3 text-center mt-5">
                                <Link to="/our_team" className="register_btn btn btn-primary text-light">
                                    View More
                                </Link>
                            </div>
                        </Col>
                    </Row>
                </div>
            </section>
        </>
    )
}

export default NewJoiners
